import { Chip, FormControlLabel, Switch } from '@mui/material'
import React from 'react'

const SecurityTab = ({user}) => {
  return (
    <div className="space-y-6">
              <h3 className="text-lg font-semibold mb-4 text-secondary-900">
                Security Settings
              </h3>
              <div className="space-y-4">
                <div className="flex justify-between items-center py-2 border-b">
                  <div>
                    <span className="text-secondary-600 block">
                      Email Verification
                    </span>
                    <span className="text-sm text-secondary-500">
                      {user.is_email_verified
                        ? "Email address has been verified"
                        : "Email address not verified"}
                    </span>
                  </div>
                  <Chip
                    label={user.is_email_verified ? "Verified" : "Unverified"}
                    color={user.is_email_verified ? "success" : "warning"}
                    size="small"
                  />
                </div>
                <div className="flex justify-between items-center py-2 border-b">
                  <div>
                    <span className="text-secondary-600 block">
                      Account Status
                    </span>
                    <span className="text-sm text-secondary-500">
                      {user.is_active
                        ? "Account is active and accessible"
                        : "Account is deactivated"}
                    </span>
                  </div>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={user.is_active}
                        onChange={() => setStatusDialogOpen(true)}
                        color="primary"
                      />
                    }
                    label=""
                  />
                </div>
                {/* <div className="flex justify-between items-center py-2 border-b">
                  <div>
                    <span className="text-secondary-600 block">Password</span>
                    <span className="text-sm text-secondary-500">
                      Last changed: Unknown
                    </span>
                  </div>
                  <MuiButton
                    variant="outlined"
                    size="small"
                    startIcon={<Shield />}
                  >
                    Reset Password
                  </MuiButton>
                </div> */}
              </div>
            </div>
  )
}

export default SecurityTab